var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box wrapper-payroll-perceptions" },
    [
      _c("div", { staticClass: "title-container is-flex" }, [
        _c(
          "h4",
          {
            staticClass:
              "title is-centered is-4 has-text-primary title-payroll-perceptions"
          },
          [_vm._v("\n      Percepciones\n    ")]
        ),
        _c(
          "div",
          { staticClass: "field is-centered" },
          [
            _c(
              "BTooltip",
              {
                staticClass: "add-button",
                attrs: { label: "Agregar percepción", type: "is-success" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "button add-percept is-success is-rounded",
                    on: {
                      click: function($event) {
                        return _vm.$store.commit("payroll/addPerceptRow")
                      }
                    }
                  },
                  [_c("BIcon", { attrs: { icon: "plus" } })],
                  1
                )
              ]
            )
          ],
          1
        )
      ]),
      _c("BTable", {
        attrs: {
          data: _vm.perceptsWithIndex,
          columns: _vm.columns,
          "opened-detailed": _vm.openedDetailed,
          "show-detail-icon": false,
          detailed: "",
          "detail-key": "id"
        },
        on: { "details-close": _vm.onDetailsClose },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(props) {
              return [
                _c(
                  "BTableColumn",
                  {
                    staticClass: "limit-300",
                    attrs: { field: "perceptType", internal: "" }
                  },
                  [
                    _c(
                      "BField",
                      [
                        _c(
                          "BSelect",
                          {
                            staticClass: "is-fullwidth",
                            attrs: {
                              name: "perceptType",
                              placeholder: "Selecciona el tipo",
                              value: props.row.perceptType,
                              disabled: _vm.loading,
                              loading: _vm.loading,
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.onChange(
                                  props.row.id,
                                  "perceptType",
                                  $event
                                )
                              }
                            }
                          },
                          _vm._l(_vm.perceptTypeCatalog, function(option) {
                            return _c(
                              "option",
                              {
                                key: option.value,
                                domProps: { value: option.value }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.label) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "key", internal: "" } },
                  [
                    _c(
                      "BField",
                      [
                        _c("BInput", {
                          attrs: {
                            name: "key",
                            placeholder: "Selecciona el tipo",
                            value: props.row.key,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onInput(props.row.id, "key", $event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "concept", internal: "" } },
                  [
                    _c(
                      "BField",
                      [
                        _c("BInput", {
                          attrs: {
                            name: "concept",
                            placeholder: "Selecciona el tipo",
                            value: props.row.concept,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onInput(
                                props.row.id,
                                "concept",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "taxedAmount", internal: "" } },
                  [
                    _c(
                      "BField",
                      [
                        _c("BInput", {
                          attrs: {
                            name: "taxedAmount",
                            placeholder: "Selecciona el tipo",
                            type: "number",
                            min: "0",
                            step: "0.01",
                            value: props.row.taxedAmount,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onInput(
                                props.row.id,
                                "taxedAmount",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "exemptAmount", internal: "" } },
                  [
                    _c(
                      "BField",
                      [
                        _c("BInput", {
                          attrs: {
                            name: "exemptAmount",
                            placeholder: "Selecciona el tipo",
                            type: "number",
                            min: "0",
                            value: props.row.exemptAmount,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onInput(
                                props.row.id,
                                "exemptAmount",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "actions", internal: "" } },
                  [
                    _c("span", { staticClass: "actions" }, [
                      _vm.perceptsWithIndex.length > 1
                        ? _c(
                            "a",
                            {
                              staticClass: "button is-danger",
                              on: {
                                click: function($event) {
                                  return _vm.$store.commit(
                                    "payroll/deletePercept",
                                    props.row.id
                                  )
                                }
                              }
                            },
                            [
                              _c("BIcon", {
                                attrs: { icon: "delete", "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ]
            }
          },
          {
            key: "detail",
            fn: function(props) {
              return [
                _c("Overtime", {
                  attrs: { id: props.row.id, disabled: _vm.disabled }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }